import { useState } from 'react';

import { Box, useMediaQuery, useTheme } from '@mui/material';
import { PaymentSheetListObj } from '../../../models/PaymentSheet';
import { TimeSheetDetailsDialog } from '../TimeSheetDetailsDialog';
import { TimeSheetsTable } from '../TimeSheetTable';
import { useTimeSheetsPageContext } from '../context/TimeSheetsPageContext';

export const TimeSheetsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [viewItem, setViewItem] = useState<PaymentSheetListObj | undefined>(undefined);

  useTimeSheetsPageContext();

  const handleViewItem = (item: PaymentSheetListObj) => {
    setViewItem(item);
  };

  const handleCloseDialogs = () => {
    setViewItem(undefined);
  };

  return (
    <Box sx={{ mt: isMobile ? 2 : 0 }}>
      <TimeSheetsTable onView={handleViewItem} />
      {viewItem && <TimeSheetDetailsDialog item={viewItem} onClose={handleCloseDialogs} />}
    </Box>
  );
};
